<template>
  <div
    class="home-pendant"
    v-if="isShowModal&&isShowPendantIndexAD && jsPCFloatTopList.length>0 && jsPCFloatLeftList.length>0 && jsPCFloatRightList.length>0 && jsPCFloatQrList.length>0"
  >
    <div class="home-popBox">
      <i class="close-btn" @click.prevent="imgHandleClick()"></i>
      <div
        class="header"
        v-if="jsPCFloatTopList.length>0"
        :style="{'background-image': 'url('+jsPCFloatTopList[0].imgLink+')'}"
      ></div>
      <div
        class="content"
        v-if="jsPCFloatLeftList.length>0||jsPCFloatRightList.length>0||jsPCFloatQrList.length>0"
      >
        <div class="left-nav-wrap">
          <ul class="left-nav" v-if="jsPCFloatLeftList.length>0">
            <li
              @mouseover="setMiddleImgIndex(index)"
              :class="{'left-nav-active': index === middleImgIndex}"
              v-for="(item,index) in jsPCFloatLeftList"
              :key="item.id"
            >
              <span>{{item.imgName}}</span>
            </li>
          </ul>
          <div class="qr" v-if="jsPCFloatQrList.length>0">
            <img :src="jsPCFloatQrList[0].imgLink" alt />
          </div>
        </div>
        <div class="right-content-wrap">
          <el-container>
            <el-main style="padding: 10px">
              <div class="middle-img-wrap" v-if="jsPCFloatLeftList.length>0">
                <div
                  class="middle-img-item"
                  v-if="index===middleImgIndex"
                  v-for="(item,index) in jsPCFloatLeftList"
                  :key="item.id"
                >
                  <a
                    v-if="item.imgClickLink"
                    target="_blank"
                    @click.prevent="goHref(item.imgClickLink)"
                    href="#"
                  >
                    <div>
                      <p>{{item.remark}}</p>
                      <img :src="item.imgLink" alt />
                    </div>
                  </a>
                  <div v-if="!item.imgClickLink">
                    <p>{{item.remark}}</p>
                    <img :src="item.imgLink" alt />
                  </div>
                </div>
              </div>
            </el-main>
            <el-aside width="223px">
              <ul class="right-img-wrap" v-if="jsPCFloatRightList.length>0">
                <li v-for="(item) in jsPCFloatRightList" :key="item.id">
                  <a
                    v-if="item.imgClickLink"
                    target="_blank"
                    @click.prevent="goHref(item.imgClickLink)"
                    href="#"
                  >
                    <img :src="item.imgLink" alt />
                  </a>
                  <img v-if="!item.imgClickLink" :src="item.imgLink" alt />
                </li>
              </ul>
            </el-aside>
          </el-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { mapMutations, mapState } from "vuex";
import { commonApi, common } from "@/common/index";

export default {
  name: "home-pendant",
  data() {
    return {
      imgList: [],
      isShowModal:true,
      middleImgIndex: 0,

      jsPCFloatTopList: [],
      jsPCFloatLeftList: [],
      jsPCFloatRightList: [],
      jsPCFloatQrList: []
    };
  },
  computed: {
    ...mapState({
      isShowPendantIndexAD: state => state.isShowPendantIndexAD
    })
  },
  methods: {
    ...mapMutations(["CLOSE_INDEX_AD", "set_CLOSE_PENDANT_AD"]),
    setMiddleImgIndex(index) {
      this.middleImgIndex = index;
    },
    imgHandleClick(index) {
      this.set_CLOSE_PENDANT_AD();
    },
    fetchImg() {
      // let jsPCFloatTop = commonApi.HOMEBEFORE.fetchImg('jsPCFloatTop');
      // let jsPCFloatLeft = commonApi.HOMEBEFORE.fetchImg('jsPCFloatLeft');
      // let jsPCFloatRight = commonApi.HOMEBEFORE.fetchImg('jsPCFloatRight');
      // let jsPCFloatQr = commonApi.HOMEBEFORE.fetchImg('jsPCFloatQr');

      // Promise.all([jsPCFloatTop, jsPCFloatLeft, jsPCFloatRight, jsPCFloatQr])
      //   .then(data => {
      //     this.jsPCFloatTopList = data[0];
      //     this.jsPCFloatLeftList = data[1];
      //     this.jsPCFloatRightList = data[2];
      //     this.jsPCFloatQrList = data[3]
      //   })
      //   .catch(err=>{
      //     this.imgList = []
      //   })

      let imgCodes = [
        "jsPCFloatTop",
        "jsPCFloatLeft",
        "jsPCFloatRight",
        "jsPCFloatQr"
      ].join(",");

      commonApi.HOMEBEFORE.fetchImgs(imgCodes)

        .then(data => {
          this.jsPCFloatTopList = data.jsPCFloatTop;
          this.jsPCFloatLeftList = data.jsPCFloatLeft;
          this.jsPCFloatRightList = data.jsPCFloatRight;
          this.jsPCFloatQrList = data.jsPCFloatQr;
          //获取上次弹框时间
          var oldTime = Number(common.getCookie("9570PendantModalTime"));
          var nowTime = Number(new Date().getTime());
          if (!oldTime) {
            this.isShowModal = true;
             common.setCookie("9570PendantModalTime", nowTime);
          } else if (
            nowTime - oldTime > 28800000 &&
            this.jsPCFloatTopList &&
            this.jsPCFloatTopList.length > 0
          ) {
            common.setCookie("9570PendantModalTime", nowTime);
            this.isShowModal = true;
          }else{
              this.isShowModal = false;
          }
        })
        .catch(err => {});
    },
    goHref(url) {
      let path = common.goHref(url);
      if (path) {
        this.$router.push({ path: path });
      }
    }
  },
  mounted() {
    this.fetchImg();
  }
};
</script>

<style scoped lang="scss">
@import "../../style/variable";
.home-pendant {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 3001;
  text-align: center;
  .home-popBox {
    position: fixed;
    z-index: 2201;
    top: 50%;
    width: 1002px;
    text-align: center;
    left: 50%;
    transform: translate(-50%, -50%);
    .close-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      top: 82px;
      right: 5px;
      z-index: 100000;
      width: 54px;
      height: 54px;
      background: url("./img/close.png") no-repeat center top;
    }
    .header {
      height: 191px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
    .content {
      height: 441px;
      background: url("./img/pop_bg.png") no-repeat center bottom;
      padding-top: 2px;
      background-size: 100% 100%;

      .left-nav-wrap {
        width: 160px;
        float: left;
        .left-nav {
          li {
            width: 158px;
            cursor: pointer;
            position: relative;
            font-size: 14px;
            color: #fff;
            border: 1px solid #9e9459;
            border-top: none;
            span {
              display: inline-block;
              position: relative;
              z-index: 3;
              vertical-align: top;
              width: 100%;
              height: 43px;
              line-height: 43px;
              padding: 0 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            &:before {
              content: none;
              position: absolute;
              z-index: 0;
              display: block;
              width: 167px;
              height: 43px;
              left: 0;
              top: 0;
              background: url("./img/item-bg.png") no-repeat left center;
              background-size: 100% 100%;
            }
            &:hover {
              border-right: none;
              color: $nav-font;
              font-weight: bolder;
              &:before {
                content: "";
              }
            }
          }
          .left-nav-active {
            border-right: none;
            color: $nav-font;
            font-weight: bolder;
            &:before {
              content: "";
            }
          }
        }

        .qr {
          padding-top: 3px;
          text-align: center;
          img {
            width: 158px;
            height: 201px;
          }
        }
      }
      .right-content-wrap {
        margin-left: 160px;
        padding-top: 2px;
        .middle-img-wrap {
          .middle-img-item {
            p {
              height: 28px;
              text-align: center;
              color: #fff;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            img {
              width: 600px;
              height: 389px;
            }
          }
        }
        .right-img-wrap {
          padding-top: 8px;
          li {
            padding: 10px 0;
            text-align: left;
            img {
              width: 210px;
              height: 120px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/build08/components/pendant/home-pendant.vue